import React from "react";

const BigGreenCircle = () => (
  <svg
    width="982"
    height="982"
    viewBox="0 0 982 982"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="491" cy="491" r="435" stroke="#0BC76D" strokeWidth="112" />
  </svg>
);

export default BigGreenCircle;
